import { useCallback } from "react";
import { getEquipment } from "../../api/EquipmentMasters";

export default function useGetEquipmentAreaDepartment() {
  const getEquipmentAreaDepartment = useCallback(async (equipId: string) => {
    const response = await getEquipment({ equipment: equipId });
    return { area: response.data.Area, department: response.data.Department };
  }, []);

  return { getEquipmentAreaDepartment };
}
